export enum TermTypeEnum {
  Adesao = 2,
  Cancelamento = 3,
}
